// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"ae996a1c","837":"21233a31"}[chunkId] + ".chunk.js";
};